import http from '@/plugins/axios/axios';

export default class MenuService {

    salvar(requisicao) {       
        return http.post('/api/menu/salvar', requisicao);
    }
    
    atualizarStatusAtivo(requisicao) {       
        return http.post('/api/menu/atualizarStatusAtivo', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/menu/excluir', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/menu/listar', requisicao);
    }

    listarPermissoes(requisicao) {       
        return http.post('/api/menu/listar-permissoes', requisicao);
    }

    pulicar(requisicao) {       
        return http.post('/api/menu/publicarPermissoes', requisicao);
    }
}